<template>
    <div>
      <Header :title="title"/>
  
      <div class="content_podat">

      <div align="center" class="ukazat" v-if="getobmenmy_car ==''">
        <span>Какая ваша машина?</span><br/><br/>
        <button class="btnss" @click="ukazatmasina()">Указать машину</button>
      </div>
      <div v-else>
        <span>{{ getobmenmy_car }}</span><br/><br/>
      </div>
            
        <div v-if="text_na_vash_mashina"><span>Эти машины хотят обменять на вашу</span></div>
      
        <div class="content_kart">
        <div v-for="get in getpostobmenobvs " :key="get.id">
            <Karta  :obvs="get" /> 
        </div>
        </div>
        <div align="center" class="spin" v-if="loading" >
            <Spinner />
        </div>
        <div align="center"> <button v-if="pei" class="btns" @click="getobvobmen()">ПОКАЗАТЬ ЕЩЕ</button></div>

        <div v-if="noobv" align="center">
            Пока нет машин, которые хотят обменять свою машину на вашу.
            Ну, вы сможете разместить свою машину, и там укажите свой вариант обмена. Владелец машины, которую вы хотите обменять, сам будет звонить, или покупатель позвонит.
            <br/><br/>
            <button class="btnss" @click="podat()">Указать машину</button>
        </div>
       

      </div>
    </div>
  </template>
  
  <script>
  import Header from '../components/headerpodat'
  import Spinner from '../blocks/spinner';
    import Karta from '../blocks/karta';
    import axios from "axios";
  export default {
     components:{
     Header, Spinner, Karta
     },
    data() {
      return {
        title:"Обмен машины",
        obmen:"",
        loading:false,
        mycarukazat:true,
        text_my_car:"",
        lenta:true,
        text_na_vash_mashina:false,
        noobv:false,
        pei:false,
      };
    },
    methods: {
      podat(){
        this.$router.push({ name: "Podat" });
      },
      ukazatmasina(){
        localStorage.setItem("statusobmen","getobmen");
        this.$router.push({ name: "kategObmen" });

      },
      mycar(){
        this.$store.commit("addobmenkateg",localStorage.getItem("obmen_kateg"));
        this.$store.commit("addobmenrazdel",localStorage.getItem("obmen_razdel"));
        this.$store.commit("addobmenmarka",localStorage.getItem("obmen_marka"));
        this.$store.commit("addobmenmodel",localStorage.getItem("obmen_model"));
        this.$store.commit("addobmentip",localStorage.getItem("obmen_tip"));
        this.$store.commit("addobmengod",localStorage.getItem("obmen_god"));
        
        if(localStorage.getItem("obmen_kateg") =="avto"){
           this.text_my_car = "Ваш: "+localStorage.getItem("obmen_marka_text")+" "+localStorage.getItem("obmen_model_text")+" "+localStorage.getItem("obmen_god");
        }else{
            this.text_my_car = "Ваш: "+localStorage.getItem("obmen_razdel_text")+" "+localStorage.getItem("obmen_marka_text")+" "+localStorage.getItem("obmen_tip_text")+" "+localStorage.getItem("obmen_god");
        }
        this.$store.commit("addobmenmy_car",this.text_my_car);

        localStorage.removeItem("obmen_kateg");
        localStorage.removeItem("obmen_kateg_text");
        localStorage.removeItem("obmen_razdel");
        localStorage.removeItem("obmen_razdel_text");
        localStorage.removeItem("obmen_marka");
        localStorage.removeItem("obmen_marka_text");
        localStorage.removeItem("obmen_model");
        localStorage.removeItem("obmen_model_text");
        localStorage.removeItem("obmen_tip");
        localStorage.removeItem("obmen_tip_text");
        localStorage.removeItem("obmen_god");
        localStorage.removeItem("statusobmen");
        localStorage.removeItem("ukazat");

        this.getobvobmen();
      },

      getobvobmen(){
        if(this.lenta){
           this.lenta=false;
           this.loading=true;
           axios({
           method: 'post',
            url: 'https://avtobaza.tj/api/getobmenobvsweb',
            data: {
                  kateg:this.getobmenkateg,
                  razdel:this.getobmenrazdel,
                  marka:this.getobmenmarka,
                  tip:this.getobmentip,
                  model:this.getobmenmodel,
                  god:this.getobmengod,
                  limit:this.getpostobmenobvs.length,
            } 
          })
        .then(res=>{
            if(res.data.status){           
                this.loading=false;
                this.lenta=true;
                this.pei=true;
                this.text_na_vash_mashina=true;
                this.$store.commit("addpostobmenobvs",res.data.obvs);
             }
              else{
                this.loading=false;
                this.pei=false;
                if(this.getpostobmenobvs ==""){
                    this.noobv=true;
                } 
                
              }
           })   
        }
       
      }
      

     
    },
    computed: {
        getpostobmenobvs(){
         return this.$store.getters.getpostobmenobvs
        },
        getobmenmy_car(){
         return this.$store.getters.getobmenmy_car
        },
        getobmenkateg(){
         return this.$store.getters.getobmenkateg
        },
        getobmenrazdel(){
         return this.$store.getters.getobmenrazdel
        },
        getobmenmarka(){
         return this.$store.getters.getobmenmarka
        },
        getobmenmodel(){
         return this.$store.getters.getobmenmodel
        },
        getobmentip(){
         return this.$store.getters.getobmentip
        },
        getobmengod(){
         return this.$store.getters.getobmengod
        },
     },

    mounted (){
        if(localStorage.getItem("ukazat")){
        this.mycar();
        }
        
        
    },
    
    
  
  };
  </script>
  <style scoped>
  .divgorod {
    width: 100%;
    color: #777777;
  }
  .contentgorod {
    font-size: 20px;
    border-bottom: 1px solid #000000;
    padding: 5px 5px 5px 0px;
  }
 
  .content_podat {
    padding: 90px 0px 0px 0px;
  }
 
  </style>